import type { ActionFunctionArgs } from '~/types/route-args';

import { passkeyRegisterOptionsAction } from '~/modules/user/passkey/passkey.server';

export const PASSKEY_REGISTER_OPTIONS_API_ROUTE =
    '/remix-api/user/passkey-register-options';

export const action = (args: ActionFunctionArgs) =>
    passkeyRegisterOptionsAction(args);

export type PasskeyRegisterOptionsAction =
    | { ok: true; optionsJSON: string }
    | { ok: false; message: string };
